import { render } from "./p2hform.vue?vue&type=template&id=397f4c2a"
import script from "./p2hform.vue?vue&type=script&lang=js"
export * from "./p2hform.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__